import React, { useState } from "react";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

import makeStyles from "@mui/styles/makeStyles";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  appBar: {
    position: "fixed",
    backgroundColor: "#ffff00",
    color: "rgba(0, 0, 0, 0.87)",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  fullWidth: {
    width: "100%",
  },
  yellowButton: {
    backgroundColor: "#ffff00",
    color: "black",
    "&:hover": {
      backgroundColor: "#ffff00",
    },
  },
}));

function Breakdown(props) {
  const classes = useStyles();

  const [openViewProductsDialog, setOpenViewProductsDialog] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState({});
  const startDate = new Date(props.formattedSelectedDate.startingDate);
  const endDate = new Date(props.formattedSelectedDate.endingDate);

  const startYear = startDate.getFullYear();
  const endYear = endDate.getFullYear();
  const startMonth = ("0" + (startDate.getMonth() + 1)).slice(-2); // Adding leading zero if necessary
  const endMonth = ("0" + (endDate.getMonth() + 1)).slice(-2); // Add
  const [selectedDate, setSelectedDate] = useState({});
  const [openViewAccountsDialog, setOpenViewAccountsDialog] = useState(false);

  const handleClose = () => {
    props.setOpenBreakdownDialog(false);
  };

  const handleCloseAccount = () => {
    setOpenViewAccountsDialog(false);
  };

  const salesBreakdown = (targets) => {
    if (!targets || !Array.isArray(targets)) {
      return null;
    }
    return (
      <List>
        {targets.map((value, index) => (
          <React.Fragment key={index}>
            <ListItem divider style={{ textAlign: "center" }}>
              <ListItemText
                primary={
                  <Typography variant="body1" style={{ fontWeight: "bold" }}>
                    {value.account_name}
                  </Typography>
                }
                secondary={
                  <Typography variant="body2">{value.account_code}</Typography>
                }
              />
            </ListItem>
            <List component="div" disablePadding>
              {value.products.map((product, productIndex) => (
                <ListItem key={productIndex} button>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography
                          variant="body2"
                          color="textPrimary"
                          sx={{ fontWeight: "bold" }}
                        >
                          {product.product_name} {`(${product.product_code})`}
                        </Typography>
                        {/* <Typography variant="body2" color="textPrimary">
                                Order Quantity: <span style={{ color: 'green' }}>{Number(product.order_quantity).toLocaleString()}</span>
                                </Typography> */}
                        <Typography variant="body2" color="textPrimary">
                          Amount:{" "}
                          <span style={{ color: "green" }}>
                            ₱
                            {Number(product.total_product_sales).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </span>
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
              ))}
            </List>
            <Typography
              variant="body1"
              color="textPrimary"
              sx={{ padding: "15px", textAlign: "right" }}
            >
              Total Sales:{" "}
              <span style={{ color: "green", fontWeight: "bold" }}>
                ₱
                {Number(value.total_sales).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </Typography>
            <Divider />
          </React.Fragment>
        ))}
      </List>
    );
  };

  const reachBreakdown = (targets) => {
    if (!targets || !Array.isArray(targets)) {
      return null;
    }
    return (
      <List>
        {targets.map((value, index) => (
          <React.Fragment key={index}>
            <ListItem button>
              <ListItemText
                primary={
                  <Typography style={{ fontWeight: "bold" }}>
                    {value.account_name} ({value.account_code})
                  </Typography>
                }
                secondary={
                  <Typography>
                    Total Sales:{" "}
                    <span style={{ color: "green", fontWeight: "bold" }}>
                      ₱{value.total_sales}
                    </span>
                  </Typography>
                }
              />
            </ListItem>
            <Divider />
          </React.Fragment>
        ))}
      </List>
    );
  };

  const rangeBreakdown = (targets) => {
    if (!targets || !Array.isArray(targets)) {
      return null;
    }

    if (startYear != endYear || startMonth != endMonth) {
      const groupedByMonthYear = targets.reduce((acc, item) => {
        const key = `${item.month} ${item.year}`;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      }, {});

      const monthYears = Object.entries(groupedByMonthYear).map(
        ([key, items]) => ({
          key,
          items,
        })
      );

      monthYears.forEach(({ key, items }) => {
        items.forEach((item) => {});
      });

      return (
        <List>
          {monthYears.map(({ key, items }, index) => {
            const uniqueAccounts = items.some(
              (item) => item.account_code !== null
            )
              ? new Set(
                  items
                    .filter((item) => item.account_code !== null)
                    .map((item) => item.account_code)
                ).size
              : 0;
            return (
              <React.Fragment key={index}>
                <ListItem
                  button
                  divider
                  onClick={() =>
                    handleViewAccountsDialog({ key, accountDetails: items })
                  }
                >
                  <ListItemText
                    primary={
                      <Typography
                        variant="body1"
                        style={{ fontWeight: "bold" }}
                      >
                        {key}
                      </Typography>
                    }
                    secondary={
                      <Typography>
                        Total Unique Accounts:{" "}
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          {uniqueAccounts}
                        </span>{" "}
                        <br />
                        Target Unique SKU:{" "}
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          {items[0].target_unique_sku}
                        </span>
                      </Typography>
                    }
                  />
                </ListItem>
                <Divider />
              </React.Fragment>
            );
          })}
        </List>
      );
    } else {
      return (
        <List>
          {targets.map((value, index) => (
            <React.Fragment key={index}>
              <ListItem button divider>
                <ListItemText
                  primary={
                    <Typography variant="body1" style={{ fontWeight: "bold" }}>
                      {value.account_name} ({value.account_code})
                    </Typography>
                  }
                  secondary={
                    <Typography>
                      Total Unique Products:{" "}
                      <span style={{ color: "green", fontWeight: "bold" }}>
                        {value.unique_product_count}
                      </span>
                    </Typography>
                  }
                  onClick={() => {
                    handleViewProductsDialog(value);
                  }}
                />
              </ListItem>
              <Divider />
            </React.Fragment>
          ))}
        </List>
      );
    }
  };

  const handleViewAccountsDialog = (value) => {
    setSelectedDate(value);
    setOpenViewAccountsDialog(true);
  };

  const viewAccountsDialog = () => {
    if (
      !selectedDate ||
      !selectedDate.accountDetails ||
      selectedDate.accountDetails.length === 0 ||
      selectedDate.accountDetails.some(
        (account) => account.account_code === null
      )
    ) {
      return null;
    }
    return (
      <Dialog
        fullScreen
        open={openViewAccountsDialog}
        onClose={handleCloseAccount}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseAccount}
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {selectedDate.key}
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.appBarSpacer}></div>
        <List>
          {selectedDate.accountDetails.map((account, index) => (
            <React.Fragment key={index}>
              <ListItem
                button
                divider
                onClick={() => {
                  handleViewProductsDialog(account);
                }}
              >
                <ListItemText
                  primary={
                    <Typography variant="body1" style={{ fontWeight: "bold" }}>
                      {account.account_name} ({account.account_code})
                    </Typography>
                  }
                  secondary={
                    <Typography>
                      Total Unique Products:{" "}
                      <span style={{ color: "green", fontWeight: "bold" }}>
                        {account.unique_product_count}
                      </span>
                    </Typography>
                  }
                />
              </ListItem>
              <Divider />
            </React.Fragment>
          ))}
        </List>
      </Dialog>
    );
  };

  const handleViewProductsDialog = (value) => {
    setSelectedAccount(value);
    setOpenViewProductsDialog(true);
  };
  const viewProductsDialog = () => {
    return (
      <Dialog open={openViewProductsDialog} maxWidth="sm" fullWidth>
        <DialogTitle style={{ fontWeight: "bold", textAlign: "center" }}>
          {selectedAccount.account_name}
        </DialogTitle>
        <DialogContent dividers>
          <List>
            {selectedAccount.products &&
              selectedAccount.products.split(",").map((value, index) => (
                <ListItem
                  button
                  divider
                  key={`${value["account_code"]}-${index}`}
                >
                  <ListItemText primary={`${index + 1}. ${value}`} />
                </ListItem>
              ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className={classes.yellowButton}
            onClick={() => {
              setOpenViewProductsDialog(false);
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const selectedBreakdown = (selected) => {
    if (selected === "Sales") {
      return salesBreakdown(props.targets.sales_breakdown);
    } else if (selected === "Reach") {
      return reachBreakdown(props.targets.reach_breakdown);
    } else if (selected === "Range") {
      return rangeBreakdown(props.targets.range_breakdown);
    } else {
      return null;
    }
  };
  return (
    <>
      <div>
        <Dialog
          fullScreen
          open={props.openBreakdownDialog}
          onClose={handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                {props.selectedBreakdown} Breakdown
              </Typography>
            </Toolbar>
          </AppBar>
          <div className={classes.appBarSpacer}></div>
          {selectedBreakdown(props.selectedBreakdown)}
          {viewProductsDialog()}
          {viewAccountsDialog()}
        </Dialog>
      </div>
    </>
  );
}

export default Breakdown;
